import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from "@chakra-ui/react";
import { ColorIcon, colors, customEvent, NextLink } from "goi_common";
import { ParlorDetailProps } from "@/types/parlor";
import { css } from "@emotion/react";
interface Props {
  path: "parlor_region" | "parlor_detail" | "parlor_detail_price" | "infrmatin_price_parlor";
  sidoName: string | null;
  sigunguName: string | undefined;
  service?: string;
  parlor?: ParlorDetailProps;
}
function ParlorRegionBreadcrumb({ path, sidoName, sigunguName, service, parlor }: Props) {
  return (
    <Breadcrumb
      display="flex"
      css={css`
        ol {
          flex-wrap: wrap;
        }
      `}
      itemScope
      itemType="https://schema.org/BreadcrumbList"
      textColor={colors.gray400}
      spacing="4px"
      separator={<ColorIcon name="arrow" color={colors.gray400} size="8px" />}
    >
      <BreadcrumbItem itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <BreadcrumbLink
          as={NextLink}
          className="caption_12_m"
          href={`/match/recommendations/`}
          itemProp="item"
          onClick={() => {
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "brdcrmb-uv_mtch_recomms",
              },
            });
          }}
        >
          <span itemProp="name">고이의 추천</span>
          <meta itemProp="position" content="1" />
        </BreadcrumbLink>
      </BreadcrumbItem>
      <BreadcrumbItem itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <BreadcrumbLink
          itemProp="item"
          as={NextLink}
          className="caption_12_m"
          href={`/parlors/region/${sidoName}/`}
          onClick={() => {
            customEvent({
              newGtm: {
                path,
                trigger_and_target: "brdcrmb-uv_sido_parlors",
                text: `${sidoName}`,
              },
            });
          }}
        >
          <span itemProp="name">{sidoName} 장례식장</span>
          <meta itemProp="position" content="2" />
        </BreadcrumbLink>
      </BreadcrumbItem>
      {sigunguName && (
        <BreadcrumbItem itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <BreadcrumbLink
            itemProp="item"
            as={NextLink}
            className="caption_12_m"
            href={`/parlors/region/${sidoName}-${sigunguName}/`}
            onClick={() => {
              customEvent({
                newGtm: {
                  path,
                  trigger_and_target: "brdcrmb-uv_sigungu_parlors",
                  text: `${sidoName}-${sigunguName}`,
                },
              });
            }}
          >
            <span itemProp="name">{sigunguName} 장례식장</span>
            <meta itemProp="position" content="3" />
          </BreadcrumbLink>
        </BreadcrumbItem>
      )}
      {service && (
        <BreadcrumbItem itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <BreadcrumbLink
            itemProp="item"
            as={NextLink}
            className="caption_12_m"
            href={`/parlors/region/service/${
              sigunguName ? `${sidoName}-${sigunguName}` : `${sidoName}`
            }/${service}/`}
            onClick={() => {
              customEvent({
                newGtm: {
                  path,
                  trigger_and_target: "brdcrmb-uv_parlor_region_service",
                  text: sigunguName ? `${sidoName}-${sigunguName}` : `${sidoName}`,
                },
              });
            }}
          >
            <span itemProp="name">{service}</span>
            <meta itemProp="position" content="4" />
          </BreadcrumbLink>
        </BreadcrumbItem>
      )}
      {parlor && (
        <BreadcrumbItem itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
          <BreadcrumbLink
            itemProp="item"
            as={NextLink}
            className="caption_12_m gray800"
            href={`/parlor/${parlor.id}/`}
            onClick={() => {
              customEvent({
                newGtm: {
                  path,
                  trigger_and_target: "brdcrmb-uv_parlor_detail",
                  text: `${parlor.companyname}`,
                },
              });
            }}
          >
            {" "}
            <meta itemProp="position" content="4" />
            <span itemProp="name" className="caption_12_b gray600">
              {parlor.companyname} 비용, 정보 더보기
            </span>
          </BreadcrumbLink>
        </BreadcrumbItem>
      )}
    </Breadcrumb>
  );
}

export default ParlorRegionBreadcrumb;
